var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 6.66817L9.33319 4.0015M1.6665 14.3348L3.92275 14.0841C4.19841 14.0535 4.33624 14.0382 4.46507 13.9965C4.57936 13.9595 4.68814 13.9072 4.78843 13.8411C4.90147 13.7665 4.99953 13.6685 5.19565 13.4724L13.9999 4.66817C14.7362 3.93179 14.7362 2.73788 13.9999 2.0015C13.2635 1.26512 12.0696 1.26512 11.3332 2.0015L2.52899 10.8057C2.33287 11.0018 2.23481 11.0999 2.16026 11.2129C2.09413 11.3132 2.04185 11.422 2.00485 11.5363C1.96314 11.6651 1.94783 11.8029 1.9172 12.0786L1.6665 14.3348Z",
    stroke: "#1E293B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.f6ecc15ed3d8b561825efcd94b842e70.svg";
export { ForwardRef as ReactComponent };